module.exports = __webpack_public_path__ + "adf5f80e779f2ccd5be7ac0b315647c3.pdf";